<template>
     <div>
        <div class="pay-items">
          <div class="row row-wrap">
            <div class="col col-3" :class="'pay_' + key" v-for="(item, key) in providers" :key="key">
              <div class="item"  v-if="item.is_active" v-show="(_.isNull(filter) || (!_.isNull(filter) && item.name.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) >= 0))">
                <div class="image">
                  <img :src="$store.state.main.cdn_url + '/providers/' +  key  + '.png?v=1.2'" height="20">
                </div>
                <h3>{{ $t('payment.services.' + key) }}</h3>
                <div class="text">
                    <div class="label">
                        <small>İşlem Süresi: </small>
                        <b>
                            <template v-if="item.minute == 1">
                                Anında 
                            </template>
                            <template v-else>
                                {{ item.minute }} Dakika
                            </template>
                          </b>
                    </div>
                    <div class="label">
                        <small>Min: </small>
                        <b>{{ item.min_pay | currency }} ₺</b>
                    </div>
                    <div class="label">
                        <small>Max: </small>
                        <b>{{ item.max_pay | currency }} ₺</b>
                    </div>
                </div>
                <div class="button primary" @click="go(key)"> 
                  <strong v-if="type == 'deposit'">Para Yatır</strong>
                  <strong v-else>Para Çek</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
     </div>
</template>

<script>
  export default{
    props:['providers', 'go', 'type','filter'],
    computed:{
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
    },
  }
</script>

<style lang="scss">
 .pay-items{
  .item{
    .text{
      width: 100%;
      margin-bottom: 10px;
      .label{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        small{
          font-size: 11px !important;
        }
        b{
          font-size: 11px !important;
          font-weight: 600;
          margin: 2px 0;
          color: var(--c);
        }
      }
    }
    h3{
      text-align: center;
      text-transform: capitalize !important;
      &:after{
        display: none !important;
      } 
    }
  } 
 }
</style>